<template>
    <section class="main">
        <v-page-header :title="$t('nav.notifications')" />

        <div class="grid-container">
            <div class="grid-x align-center">
                <div class="cell medium-10 large-12">
                    <div class="box">
                        <v-table :isLoading="notificationsTableLoading" :columns="notificationsTableColumns" :items="notificationsTableItems" :showShowAll="false" @rowClicked="onClickNotification">
                            <template slot="date" slot-scope="{ row }">
                                <span class="table-date">
                                    {{ row.createdon.date | moment('DD') }}<span>{{ row.createdon.date | moment('MMM') }}</span>
                                </span>
                            </template>
                            <template slot="title" slot-scope="{ row }">
                                <span class="table-label">{{ row.title }}</span>
                                <span class="table-description">{{ row.description }}</span>
                            </template>
                        </v-table>
                        <v-pagination :currentPage="notificationsCurrentPage" :itemsPerPage="notificationsItemsPerPage" :items="notificationsTableItemsCount" @pageClicked="onChangeNotificationsTablePage" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';

    import Table from './../partials/Foundation/Table';
    import Pagination from './../partials/Foundation/Pagination';

    export default {
        data() {
            return {
                notificationsCurrentPage        : this.$route.query.page || 1,
                notificationsItemsPerPage       : 10,
                notificationsTableLoading       : true,
                notificationsTableColumns       : [{
                    key                             : 'date',
                    width                           : '55px'
                }, {
                    key                             : 'title'
                }],
                notificationsTableItems         : [],
                notificationsTableItemsCount    : 0
            }
        },
        components : {
            vPageHeader     : PageHeader,
            vPageLoading    : PageLoading,
            vTable          : Table,
            vPagination     : Pagination
        },
        created : function () {
            this.onUpdateNotificationsTableItems(true);
        },
        methods : {
            onUpdateFilterParameters: function () {
                let query = {
                    'page' : this.notificationsCurrentPage
                };

                //for (let key in this.notificationsTableFilter) {
                //    if (this.notificationsTableFilter[key]) {
                //        query[key] = this.notificationsTableFilter[key];
                //    }
                //}

                this.$router.push({query : query});
            },
            onChangeNotificationsTablePage : function (page) {
                this.notificationsCurrentPage = page;

                this.onUpdateNotificationsTableItems();
            },
            onUpdateNotificationsTableItems : function (firstUpdate) {
                if (!firstUpdate) {
                    this.onUpdateFilterParameters();
                }

                let promise = this.$api.clearParams()
                    .setPageParams(this.notificationsCurrentPage, this.notificationsItemsPerPage)
                    .get('notifications');

                promise.then((response => {
                    var items = [];

                    response.data.data.forEach((function (item) {
                        let type = item.entity.split('\\').pop().toLowerCase();

                        if (type === 'project') {
                            items.push({
                                title       : this.$t('home.notifications.project_' + item.event, {
                                    project_number  : item.object.data.project_number
                                }),
                                description : this.$t('home.notifications.project_' + item.event + '.desc', {
                                    project_number  : item.object.data.project_number,
                                    company         : item.object.data.location.company_name
                                }),
                                createdon   : item.createdon,
                                route       : { name : 'customers-view-customer-project', params : { customer : item.customer_id, project : item.entityId } }
                            })
                        }
                    }).bind(this));

                    this.notificationsTableItems        = items;
                    this.notificationsTableItemsCount   = response.data.meta.pagination.total;
                }).bind(this)).catch((error => {
                    this.notificationsTableItems        = [];
                    this.notificationsTableItemsCount   = 0;
                }).bind(this)).finally((() => {
                    this.notificationsTableLoading      = false;
                }).bind(this));

                this.notificationsTableLoading = true;
            },
            onClickNotification : function(notification) {
                this.$router.push(notification.route);
            }
        }
    }
</script>